import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';

import axios from 'axios';

import Directives from './directives';

import {
  InputComponent,
  DropdownComponent,
  TextareaComponent,
  CheckboxComponent,
  ModalComponent,
  ActionsDropdownComponent,
  FileHandlerComponent,
  Format,
} from 'vortec-components-front';
import storage from './composables/storage';
declare global {
  interface Window {
    authenticated: boolean;
    handleThemeChange: () => void;
    defaultErrorMessage: string;
  }
}

declare module 'vue' {
  interface ComponentCustomProperties {
    window: Window;
    $format: Format;
  }
}

declare module 'vue-router' {
  interface RouteMeta {
    navigator?: boolean;
    authenticated?: boolean;
  }
}

window.authenticated = false;
window.defaultErrorMessage = 'An error occurred. Please try again later.';
window.handleThemeChange = (() => {
  const setThemeClass = (isDarkMode: boolean) => {
    document.documentElement.classList.toggle('dark-theme', isDarkMode);
  };

  const createOrUpdateMetaTag = (name: string, content: string, media: string) => {
    let metaTag = document.head.querySelector(`meta[name="${name}"][media="${media}"]`);
    if (!metaTag) {
      metaTag = document.createElement('meta');
      metaTag.setAttribute('name', name);
      metaTag.setAttribute('media', media);
      document.head.appendChild(metaTag);
    }
    metaTag.setAttribute('content', content);
  };

  const initializeMetaTags = () => {
    createOrUpdateMetaTag('theme-color', '#fdfeff', '(prefers-color-scheme: light)');
    createOrUpdateMetaTag('theme-color', '#222', '(prefers-color-scheme: dark)');
  };

  let mediaQueryListener: ((e: MediaQueryListEvent) => void) | null = null;

  return () => {
    const theme = storage<'auto' | 'light' | 'dark'>('dhig-theme', 'auto');
    if (theme.value === 'auto') {
      const prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
      setThemeClass(prefersDarkMode);

      if (!mediaQueryListener) {
        mediaQueryListener = (e) => setThemeClass(e.matches);
        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', mediaQueryListener);
      }

      initializeMetaTags();
    } else {
      const isDarkMode = theme.value === 'dark';
      setThemeClass(isDarkMode);

      createOrUpdateMetaTag(
        'theme-color',
        isDarkMode ? '#222' : '#fdfeff',
        isDarkMode ? '(prefers-color-scheme: light)' : '(prefers-color-scheme: dark)'
      );
    }
  };
})();

router.beforeEach((to, from, next) => {
  const authToken = document.cookie.split('; ').find((row) => row.startsWith('auth_token='));
  window.authenticated = !!authToken;

  if (to.meta.authenticated && !window.authenticated) {
    return next({ name: 'AuthPage' });
  } else if (to.meta.authenticated === false && window.authenticated) {
    return next({ name: 'PolicyView' });
  }

  next();
});

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
axios.defaults.withCredentials = true;

// axios
//   .get('/api/insuree-policies/validate')
//   .then((response) => {
//     window.authenticated = true;
//     window.theme = response.data.theme || 'auto';
//   })
//   .catch((error) => {
//     window.authenticated = false;
//     window.theme = error.response.data.theme || 'auto';
//   })
//   .finally(() => {
window.handleThemeChange();
Directives(app);

app.config.globalProperties.window = window;
app.config.globalProperties.$format = new Format();

app.component('InputComponent', InputComponent);
app.component('DropdownComponent', DropdownComponent);
app.component('TextareaComponent', TextareaComponent);
app.component('ModalComponent', ModalComponent);
app.component('CheckboxComponent', CheckboxComponent);
app.component('FileHandlerComponent', FileHandlerComponent);
app.component('ActionsDropdownComponent', ActionsDropdownComponent);

app.use(router);
app.mount('#daily-health');
// });
